import React from 'react'
import {useStaticQuery, graphql, Link} from 'gatsby'
import styled from 'styled-components'
import Img from 'gatsby-image'
import {Inner} from '../styles'
import {formatMoney} from '../../utils'

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto auto;
  padding: 40px 0;
  background: ${({theme}) => theme.grey4};
`
const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding-top: 40px;
  padding-bottom: 40px;
  @media (max-width: 700px) {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, 1fr);
  }
`
const ProductContainer = styled(Link)`
  transition: 0.2s all ease-in-out;
  box-shadow: 0 5px 15px 0 rgba(50, 50, 93, 0.07);
  margin: 20px;
  background: #fff;
  padding: 20px 20px 10px 20px;
  border-radius: 3px;
  .button-pill {
    border-radius: 200px;
    border: 2px solid ${({theme}) => theme.grey2};
    color: ${({theme}) => theme.grey2};
    padding: 5px 20px;
    display: inline-block;
    margin: 10px 0;
    transition: 0.2s all ease-in-out;
  }
  &:hover {
    transform: translateY(-5px);
    .button-pill {
      background: ${({theme}) => theme.redHover};
      border: 2px solid ${({theme}) => theme.redHover};
      color: #fff;
    }
  }
`
const Title = styled.h3`
  padding: 10px 0;
  text-transform: initial;
  margin: 0;
`
const SubTitle = styled.div`
  border: none;
  margin: 0;
`
const Badge = styled.div`
  font-weight: 400;
  padding: 2px 8px;
  background: ${({theme}) => theme.grey5};
  color: rgba(0, 0, 0, 0.4);
  display: inline-block;
  margin: 5px 5px 5px 0;
  border-radius: 3px;
  text-transform: uppercase;
  font-size: 12px;
`
const Divider = styled.div`
  border-top: 5px solid
    ${({theme, main}) => (main ? theme.redHover : theme.grey2)};
  width: ${({main}) => (main ? '50px' : '30px')};
  margin: ${({main}) => (main ? '20px auto' : '15px 0')};
`
const Price = styled.h4`
  border: none;
  margin: 0;
  font-weight: bold;
  span {
    font-size: 10px;
    display: block;
    line-height: 10px;
    color: rgba(0, 0, 0, 0.4);
  }
`

// This is the "Featured Products" you see on many pages
export default function MainProducts({title}) {
  const data = useStaticQuery(graphql`
    query {
      allWcProducts(
        filter: {
          categories: {elemMatch: {name: {eq: "Mattresses"}}}
          catalog_visibility: {eq: "visible"}
          status: {eq: "publish"}
        }
      ) {
        edges {
          node {
            wordpress_id
            name
            price
            sku
            slug
            categories {
              name
            }
            sale_price
            stock_status
            description
            attributes {
              name
              options
            }
            product_variations {
              price
              id
              sku
              stock_status
              attributes {
                name
                option
              }
            }
            images {
              src
              localFile {
                childImageSharp {
                  fluid(quality: 80, maxWidth: 400, srcSetBreakpoints: [200]) {
                    ...GatsbyImageSharpFluid_withWebp_noBase64
                  }
                }
                name
              }
            }
          }
        }
      }
    }
  `)

  return (
    <Container>
      <Inner>
        <h2 className="red">
          <strong>{title}</strong> Products
        </h2>
        <GridContainer>
          {data.allWcProducts.edges.map((edge, i) => (
            <ProductContainer
              to={`/product/${edge.node.slug}/`}
              key={edge.node.slug}
            >
              <Img
                fluid={edge.node.images[0].localFile.childImageSharp.fluid}
                alt={edge.node.name}
              />
              <Title>{edge.node.name}</Title>
              <SubTitle>
                {edge.node.categories.map(categ => (
                  <Badge key={categ.name}>{categ.name}</Badge>
                ))}
              </SubTitle>
              <Divider />
              <Price>
                <span>FROM</span>
                {formatMoney(edge.node.price)}
              </Price>
              <div className="button-pill">Purchase</div>
            </ProductContainer>
          ))}
        </GridContainer>
      </Inner>
    </Container>
  )
}
